export const config = {
  id: 'oregonTier1',
  path: '/oregon-tier-1',
  show: () => true,
};
